const WEATHER_CODE_ICON_KEYS = {
    1: 'pioviggine',
    2: 'pioggia_debole',
    3: 'pioggia_moderata',
    4: 'pioggia_forte',
    5: 'temporale_lieve',
    6: 'temporale_debole',
    7: 'temporale_moderato',
    8: 'temporale_forte',
    9: 'nubifragio',
    10: 'nevischio',
    11: 'neve_debole',
    12: 'neve_moderata',
    13: 'neve_forte',
    14: 'temporale_neve_lieve',
    15: 'temporale_neve_debole',
    16: 'temporale_neve_moderato',
    17: 'temporale_neve_forte',
    18: 'pioggia_mista_neve',
    19: 'temporale_pioggia_mista_neve',
    20: 'possibilita_pioggia',
    21: 'possibilita_temporale',
    22: 'temporale_possibile_grandine',
    23: 'pioviggini_intermittenti',
    24: 'pioggia_debole_intermittente',
    25: 'temporale_lieve_intermittente',
    26: 'temporale_debole_intermittente',
    27: 'nevischio_intermittente',
    28: 'neve_debole_intermittente',
    29: 'temporale_neve_lieve_intermittente',
    30: 'temporale_neve_debole_intermittente',
    31: 'sereno',
    32: 'poco_nuvoloso',
    33: 'nuvoloso',
    34: 'molto_nuvoloso',
    35: 'coperto',
    36: 'poco_nuvoloso_veli',
    37: 'nuvoloso_veli',
    38: 'molto_nuvoloso_veli',
    39: 'coperto_veli',
    40: 'foschia',
    41: 'foschia_sabbia',
    42: 'nebbia',
    70: 'possibilita_temporale_nevoso',
    71: 'possibilita_neve',
    72: 'nubifragio_fulmini'
};
const TIME_VARIANT_KEYS = new Set([
    'sereno',
    'poco_nuvoloso',
    'nuvoloso',
    'molto_nuvoloso',
    'coperto',
    'poco_nuvoloso_veli',
    'nuvoloso_veli',
    'molto_nuvoloso_veli',
    'coperto_veli',
    'foschia',
    'foschia_sabbia',
    'possibilita_pioggia',
    'possibilita_temporale',
    'possibilita_temporale_nevoso',
    'possibilita_neve',
    'pioviggini_intermittenti',
    'pioggia_debole_intermittente',
    'temporale_lieve_intermittente',
    'temporale_debole_intermittente',
    'nevischio_intermittente',
    'neve_debole_intermittente',
    'temporale_neve_lieve_intermittente',
    'temporale_neve_debole_intermittente'
]);

// One icon contract shared by map markers and station hourly cards.
export function weatherIconKey(rawValue, code, night) {
    const raw = String(rawValue || '').trim();
    const numeric = Number(raw || code);
    let key = Number.isInteger(numeric) && WEATHER_CODE_ICON_KEYS[numeric] ? WEATHER_CODE_ICON_KEYS[numeric] : raw;
    key = key.replace(/\.webp$/i, '').replace(/[^a-z0-9_ -]/gi, '').trim().replace(/[\s-]+/g, '_').toLowerCase();
    if (!key) key = 'nuvoloso';
    return TIME_VARIANT_KEYS.has(key) ? `${key}_${night ? 'notte' : 'giorno'}` : key;
}
export function hourlyWeatherIcon(code, night) {
    if (!Number.isInteger(code)) return null;
    // Legacy clear/cloud cover codes use the same nine sky states.
    const normalized = code === 0 ? 31 : code >= 43 && code <= 51 ? code-12 : code >= 52 && code <= 60 ? code-21 : code;
    if (!WEATHER_CODE_ICON_KEYS[normalized]) return null;
    return weatherIconKey('', normalized, night);
}
// Solar position at the forecast location/instant, independent of browser timezone.
export function isDayAt(time, lat, lon) {
    const date = new Date(time);
    if (!Number.isFinite(date.getTime()) || !Number.isFinite(lat) || !Number.isFinite(lon)) return null;
    const rad=Math.PI/180, d=date.getTime()/86400000-10957.5;
    const M=rad*(357.5291+0.98560028*d), L=M+rad*(1.9148*Math.sin(M)+0.02*Math.sin(2*M)+0.0003*Math.sin(3*M)+102.9372)+Math.PI;
    const e=rad*23.4397, dec=Math.asin(Math.sin(L)*Math.sin(e)), ra=Math.atan2(Math.sin(L)*Math.cos(e),Math.cos(L));
    const H=rad*(280.16+360.9856235*d+lon)-ra;
    const altitude=Math.asin(Math.sin(lat*rad)*Math.sin(dec)+Math.cos(lat*rad)*Math.cos(dec)*Math.cos(H));
    return altitude>=-0.833*rad;
}
